import React from "react";
import { FormGroup, FormGroupVerticalInput, LabelForm } from "../form";
import { getInputErrorMessage } from "../../utils";
import PositionToggle from "./PositionToggle";

const PositionFormToggle = ({
  labelText,
  fieldName,
  errors,
  handleChangeFormData,
  checked,
}) => {
  return (
    <FormGroup>
      <LabelForm text={labelText} htmlFor={fieldName} className="w-[200px]" />
      <FormGroupVerticalInput error={getInputErrorMessage(errors, fieldName)}>
        <PositionToggle
          handleChangeModal={handleChangeFormData}
          checked={checked || "0"}
          fieldName={fieldName}
        />
      </FormGroupVerticalInput>
    </FormGroup>
  );
};

export default PositionFormToggle;
